export default function _classCheckPrivateStaticAccess(receiver, classConstructor) { 
  if (receiver !== classConstructor) {
    throw new TypeError("Private static access of wrong provenance");
  } 
}
